import React from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import img2 from '../dentist.jpg';

function CardOne() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid item>
      <Grid container justifyContent="center" alignItems="center" sx={{ padding: '20px' }}>
        <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 }, textAlign: 'center' }}>
          <Typography sx={{ marginBottom: '10px', fontSize: '35px', fontWeight: 500 }}>
            Dental Implants
          </Typography>
          <Typography
            sx={{
              fontSize: '20px',
              marginBottom: '15px',
              lineHeight: '2.0',
              paddingLeft: isSmallScreen ? '10px' : '25px',
              paddingRight: isSmallScreen ? '10px' : '25px'
            }}
          >
            Dental implants, which look and feel like natural teeth, are the ideal solution for
            missing teeth. Our experienced in-house implantology team, consists of an oral surgeon,
            a periodontist, and a prosthodontist under one roof. In most of the cases, we can
            complete both single-tooth and full-mouth implants in a single sitting or within 72
            hours.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ order: { xs: 1, md: 2 }, padding: isSmallScreen ? '10px' : '18px' }}
        >
          <img
            src={img2}
            alt="Second Half Image"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CardOne;
